import EpisodicItem from './episodic-item.entity';
import ChangeEpisodicItem from '../change-episodic-items/change-episodic-item.entity';
import { SosListResponse } from '../sos-response';
import { EpisodicBaseESDoc } from '../types';
import CmWrapBox from '../cm-wrap-boxes/cm-wrap-box.entity';
import CmWrapBoxEpisodicItem from '../cm-wrap-box-episodic-items/cm-wrap-box-episodic-item.entity';

export interface EpisodicItemESDoc extends EpisodicBaseESDoc {
	name: string;
	brand: string;
	color: string;
	description: string;
	char_first_name: string;
	char_last_name: string;
	char_num: string;
	ep_char_id: number;
}

export interface EpisodicItemsForChangeListResponse extends SosListResponse {
	listed: {
		ChangeEpisodicItem: ChangeEpisodicItem[];
		EpisodicItem: EpisodicItem[];
		CmWrapBox: CmWrapBox[];
		CmWrapBoxEpisodicItem: CmWrapBoxEpisodicItem[];
	};
}

export interface EpisodicItemsForCharacterListResponse extends SosListResponse {
	listed: {
		EpisodicItem: EpisodicItem[];
		CmWrapBox: CmWrapBox[];
		CmWrapBoxEpisodicItem: CmWrapBoxEpisodicItem[];
	};
}

export interface EpisodicItemsWithoutCharacterListResponse {
	listed: {
		EpisodicItem: EpisodicItem[];
		CmWrapBox: CmWrapBox[];
		CmWrapBoxEpisodicItem: CmWrapBoxEpisodicItem[];
	};
}
